module.exports = __webpack_public_path__ + "media/images/thumbs/biology/m_animation_red_blood_cell_production_6-a498959f1c4403007c04c5facdc9659b.jpg";